import React, { useEffect } from 'react';
import withRouter from '../Components/Common/withRouter';

//redux
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';

const NonAuthLayout = ({ children }: any) => {
    const nonauthData = createSelector(
        (state) => state.Layout,
        (layout) => ({
            layoutModeType: layout.layoutModeType
        })
    );
    // Inside your component
    const { layoutModeType } = useSelector(nonauthData);

    useEffect(() => {
        document.body.setAttribute("data-bs-theme", "dark");
        return () => {
            document.body.removeAttribute("data-bs-theme")
        }
    }, [layoutModeType]);
    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
};

export default withRouter(NonAuthLayout);
